import React, {forwardRef, useEffect, useImperativeHandle, useRef, useState} from "react";
import {IconChangeSource, IconClose} from "../../Icon";
import {t} from "i18next";
import {Dropdown, type MenuProps, message, Modal, Tooltip,Image} from "antd";
import {
    createCopyLink,
    generateUUID2, getAudioFilterExt,
    getFileNameExt,
    getImagePathWithTheme,
    getLocalFilePath,
    imgPathPerfix, isAudioFileElement, isDarkMode, isImage
} from "@/utils";
import {pauseAllVideo} from "@/Utility";
import {createLibraryItemMenu} from "@/MenuUtils";
import {getCardDoc, updateCard, updateChangeSource} from "@model/card";
import {postMessage} from "@/common/event";
import {
    EVENT_FAVIRIATE_CHANGE,
    EVENT_REFRESH_LIBRARY_LIST,
    EVENT_REFRESH_RECENTS, FROM_DIALOG,
    FROM_LIBRARY,
    KEY_FILE_DIR, MAX_Z_INDEX
} from "@/Const";
import {deleteAllCardFromRefProject} from "@model/note";
import {editDoc} from "@model/doc";
import {ipcInvoke, ipcSend} from "@/common/ipc";
import CustomAudio from "../../../@excalidraw/packages/excalidraw/components/Audio/CustomAudio";
import {useAtom} from "jotai";
import {atomCardItemPointerEvent} from "@/views/Home/HomeIndex";
import global from "@/global";
import {dbGetHighlight, dbGetHighlightByLibraryId} from "@model/highlight";
import {exportCurrentElementVideoNotes, importTranscriptFromContent, onImportHighlights} from "@/VideoHighlightUtils";
import {updateTranscript} from "@model/transcript";
import {saveElementVideoNotesAsJSON} from "../../../@excalidraw/packages/excalidraw/data/json";

const DialogMediaView = forwardRef((props:{onCloseCallback:any,data:any}, ref)=>{
    useImperativeHandle(ref,()=>({
        onShowDialog:onShowDialog,
        getIsPin:getIsPin,
        showOrHidden:showOrHidden
    }))
    const [menuItems,setMenuItems] = useState<MenuProps['items']>([]);
    const [isShowDialog,setIsShowDialog] = useState(false);
    const [data,setData] = useState<any>();
    const customAudioRef = useRef(null);
    const [size,setSize] = useState({width:document.body.clientWidth*0.7,height:document.body.clientHeight*0.8})

    const [isPin,setIsPin] = useState(false);
    const [hasMaskLayer,setHasMaskLayer] = useState(true);

    const nWidth = document.body.clientWidth*0.8;
    let nHeight = document.body.clientHeight*0.85;
    if (props.data.type == 'audio'){
        nHeight = 200;
    }
    const [x, setX] = useState((document.body.clientWidth-nWidth)*0.5); // div 的左上角 x 坐标
    const [y, setY] = useState((document.body.clientHeight - nHeight)*0.5); // div 的左上角 y 坐标
    const [pointerEvents,setPointerEvents] = useState('all');
    const [cardItemPointerEvent,setCardItemPointerEvent] = useAtom(atomCardItemPointerEvent);
    //拖拽
    const mIsDragging = useRef<any>(false);
    const offset = useRef<any>({x:0,y:0});
    const mResizing = useRef(null);
    const initialMousePos = useRef<any>({ x: 0, y: 0});
    const [dialogSize,setDialogSize] = useState<any>({width:nWidth,height:nHeight});
    const draggleRef = useRef<HTMLDivElement>(null!);
    const dragTransform = useRef<any>('translate(0px, 0px)');
    const [isVisible,setIsVisible] = useState(true);


    const onShowDialog = (data:any)=>{
        setIsShowDialog(true);
        setData(data);
        if (data?.type == 'audio'){
            setSize({width:600,height:180});
        }
        setHasMaskLayer(window.getDialogPinCount() == 0);
    }

    const createMenu = async ()=>{
        const arrayMenus = (createLibraryItemMenu('',false,data));
        if (data.type == 'video' || data.type == 'audio'){
            let szFilePath = data.fileName;
            if (!data.isAbsolutePath) {
                szFilePath = localStorage.getItem(KEY_FILE_DIR)+data.fileName;
            }
            const isExist = await ipcInvoke('is-file-exist',{filePath:szFilePath});
            if (!isExist) {
                arrayMenus.splice(0,0,{
                    label: t("Change source"),
                    key: 'changeSource',
                    icon: <IconChangeSource/>
                })
            }
        }
        setMenuItems(arrayMenus);
    }

    useEffect(()=>{
        setData(props.data);
        if (data?.type == 'audio'){
            setSize({width:600,height:180});
        }
        setHasMaskLayer(window.getDialogPinCount() == 0);
    },[props.data])

    useEffect(()=>{
        if (data){
            createMenu();
        }
    },[data])

    useEffect(() => {
        if (isPin){
            if (global.g_isHiddenAllFloatWin){
                //有隐藏的
                window.visibleAllFloatWin();
            }
        }
    }, [isPin]);

    useEffect(()=>{
        if (global.g_isCtrlPressed){
            setIsPin(true);
            setHasMaskLayer(false);
        }

        document.body.addEventListener('mousemove',handleMouseMove);
        document.body.addEventListener('mouseup',handleMouseUp);
        return ()=>{
            document.body.removeEventListener('mousemove',handleMouseMove);
            document.body.removeEventListener('mouseup',handleMouseUp);

        }
    },[])

    const getIsPin = ()=>{
        return isPin;
    }

    /**
     * 显示或隐藏
     */
    function showOrHidden(){
        if (global.g_isHiddenAllFloatWin){
            setIsVisible(false)
        }else{
            setIsVisible(true)
        }
    }

    const handleMenuClick = async (e)=>{
        const szAction = e.key;
        const item = data;
        if (szAction == 'delete') {
            window.showMessageBox(t("Tips"),t("ConfirmDeleteLibraryItem"),t("Cancel"),t("Delete"),null,()=>{
                setIsShowDialog(false);
                props.onCloseCallback(props.data);
                item.isDeleted = 1;
                item.deleteTime = Date.now();
                updateCard(item).then(res=>{
                    postMessage(EVENT_FAVIRIATE_CHANGE);
                    postMessage(EVENT_REFRESH_RECENTS);
                    postMessage(EVENT_REFRESH_LIBRARY_LIST);
                    //刷新tableview
                    window.globalRefreshList('refresh_tableview_single_data_',props.data.id);
                });
                //删除这个card所关联的项目
                deleteAllCardFromRefProject(item);
            })
        }else if (szAction == 'rename'){
            window.showCommonInput(item.name,t("Rename"),"",t("Cancel"),t("Save"),(szContent:string)=>{
                window.closeCommonInput();
                item.name = szContent;
                setData({...item});
                updateCard(item).then(res=>{
                    //不知道啥排序，直接刷新列表。。
                    postMessage(EVENT_REFRESH_LIBRARY_LIST)
                });
            });
        }else if (szAction == 'exportCardPdf'){
            //card to pdf
            const szHtmlDoc:any = await getCardDoc(item.id);
            editDoc(item.id,szHtmlDoc,item.name).then(res=>{
                setTimeout(() => {
                    ipcSend('save-pdf-to-system', item.id, item.name)
                }, 10);
            })
        }else if (szAction == 'exportPdf' || szAction == 'exportVideo' || szAction == 'exportAudio' || szAction == 'exportFile'){
            //导出文件
            const szFilePath = localStorage.getItem(KEY_FILE_DIR) + item.fileName;
            ipcSend('saveFile', {
                filters: [{name: "All file", extensions: ['*']}],
                filePath: szFilePath,
                fileName: item.name+'.'+getFileNameExt(item.fileName)
            })
        }else if (szAction == 'managerTags'){
            //管理标签
            window.showManageTags([item]);
        }else if (szAction == 'addToProject'){
            //添加到project.
            window.showDialogChooseProject([item]);
        }else if (szAction == 'makeACopy'){
            const szHtml = await getCardDoc(item.id);
            const newItem = {
                ...item,
                id:generateUUID2(),
                name:item.name+"("+t("Copy")+")",
                doc:szHtml
            }
            updateCard(newItem).then(res=>{
                postMessage(EVENT_REFRESH_LIBRARY_LIST);
                message.info(t("Copyed"))
            });
        }else if (szAction == 'viewAllHighlights'){
            window.showPdfPreview(item.name,item.id,item.fileName,true,true)
        }else if (szAction == 'addToProjectChecked'){
            // addToProjectEvent();
        }else if (szAction == 'managerTagsChecked'){
            // managerTagsEvent();
        }else if (szAction == 'deleteChecked'){
            // deleteSelectedEvent();
        }else if (szAction == 'favor'){
            if (item.isFavirated){
                item.isFavirated = 0;
            }else{
                item.isFavirated = 1;
            }
            item.favirateTime = Date.now();
            updateCard(item,false).then(res=>{
                postMessage(EVENT_FAVIRIATE_CHANGE);
                postMessage(EVENT_REFRESH_LIBRARY_LIST);
            });
        }else if (szAction == 'showInfo'){
            window.showInfo('library',item);
        }else if (szAction == 'versionHistory'){
            window.showDialogCardHistory(item.id);
        }
        else if (szAction == 'copyLink'){
            createCopyLink("library", item.id,item.type,null);
        }else if (szAction == 'select'){
            //选择这一个...
            // if (item.type == 'add' && props.type == 'image'){
            //     //添加图片
            //     setIsShowDialogChooseImage(true);
            //     setTimeout(()=>{
            //         dialogChooseImageRef.current?.onShowDialog();
            //     },150);
            // }else{
            //     if (props.onItemSelectedCallback){
            //         if (item.type == 'card'){
            //             item.doc = await getCardDoc(item.id);
            //         }
            //         props.onItemSelectedCallback(item);
            //     }
            // }
        }else if (szAction == 'exportMarkdown'){
            // onExportSingleMd(item);
        }else if (szAction == 'add'){
            // onAddNewItem();
        }else if (szAction == 'edit'){
            // const doc = await getCardDoc(item.id);
            // Global.g_currentNoteData = {...item, doc};
            // openEditor(item.id,false,props.from == FROM_LIBRARY,props.from);
        }else if (szAction == 'showInSystemExporler'){
            ipcSend("show-in-exporler",((item.isAbsolutePath?'':localStorage.getItem(KEY_FILE_DIR)))+item.fileName)
        }else if (szAction == 'changeSource'){
            let filter = [{ name: 'Videos', extensions: ['mp4', 'mov', '3gp','mpeg'] }];
            if (data.type == 'audio'){
                filter = [{ name: 'audio', extensions: getAudioFilterExt() }];
            }
            ipcInvoke('getFilePath',{filters:filter}).then(async (res)=>{
                if (res){
                    //删除第一个
                    const arrayNewMenus = [...menuItems];
                    if (arrayNewMenus[0].key == 'changeSource'){
                        arrayNewMenus.splice(0,1);
                        setMenuItems(arrayNewMenus);
                    }
                    const szNewFilePath = await updateChangeSource(item.id,res);
                    //重新更新视频地址
                    const newData = {...data};
                    newData.fileName = szNewFilePath;
                    setData(newData);
                    postMessage(EVENT_REFRESH_LIBRARY_LIST);
                }
            })
        }else if (szAction == 'importTranscript'){
            //导入--字幕
            window.showDialogImportTranscript((file,content)=>{
                let arrayResults = importTranscriptFromContent(content);
                //保存....
                console.log(arrayResults);
                if (arrayResults && arrayResults.length > 0){
                    updateTranscript({id:item.id,data:arrayResults}).then(res=>{
                        window.globalRefreshList('refresh_transcript_');
                        window.globalRefreshList('switch_to_transcript_');
                    });
                }

            })
        }else if (szAction == "importHighlights"){
            //导入--注记
            window.showDialogImportHighlight(async (file,content)=>{
                let highlight:any = await dbGetHighlight(item.id);
                if (!highlight){
                    highlight = {...item,data:[]};
                }
                onImportHighlights(file,content,highlight);
                message.info(t('Highlight saved'));
            });
        }else if (szAction == "exportHighlights"){
            //导出注记
            let highlight:any = await dbGetHighlight(item.id);
            if (!highlight){
                highlight = {...item,data:[]};
            }
            saveElementVideoNotesAsJSON(exportCurrentElementVideoNotes(highlight));
        }
    }

    const handleMouseDown = (corner) => (e) => {
        mResizing.current = (corner);
        initialMousePos.current = ({ x: e.clientX, y: e.clientY });
        e.preventDefault();
        e.stopPropagation();
    };

    const handleMouseMove = (e) => {
        if (mResizing.current){
            e.stopPropagation();
            setPointerEvents('none');
            setCardItemPointerEvent('none');

            const rect = draggleRef.current.getBoundingClientRect();
            const deltaX = e.clientX - initialMousePos.current.x;
            const deltaY = e.clientY - initialMousePos.current.y;
            let nWidth = 0,nHeight =0;

            switch (mResizing.current) {
                case 'top-left':
                    nWidth = (Math.max(rect.width - deltaX, 50));
                    nHeight = (Math.max(rect.height - deltaY, 50));
                    setX(rect.left + deltaX);
                    setY(rect.top + deltaY);
                    break;
                case 'top-right':
                    nWidth = (Math.max(rect.width + deltaX, 50));
                    nHeight = (Math.max(rect.height - deltaY, 50));
                    setY(rect.top + deltaY);
                    break;
                case 'bottom-left':
                    nWidth = (Math.max(rect.width - deltaX, 50));
                    nHeight = (Math.max(rect.height + deltaY, 50));
                    setX(rect.left + deltaX);
                    break;
                case 'bottom-right':
                    nWidth = (Math.max(rect.width + deltaX, 50));
                    nHeight = (Math.max(rect.height + deltaY, 50));
                    break;
                case "left":
                    nWidth = (Math.max(rect.width - deltaX, 50));
                    nHeight = rect.height;
                    setX(rect.left + deltaX);
                    break;
                case "top":
                    nWidth = rect.width;
                    nHeight = (Math.max(rect.height - deltaY, 50));
                    setY(rect.top + deltaY);
                    break;
                case "right":
                    nWidth = (Math.max(rect.width + deltaX, 50));
                    nHeight = rect.height;
                    break;
                case "bottom":
                    nWidth = rect.width;
                    nHeight = (Math.max(rect.height + deltaY, 50));
                    break;
                default:
                    break;
            }

            if (nWidth < 520){
                nWidth = 520;
            }
            if (nHeight < 600){
                nHeight = 600;
            }

            setDialogSize({
                width: nWidth,
                height: nHeight,
                maxHeight: '100vh'
            })

            initialMousePos.current = ({ x: e.clientX, y: e.clientY });
        }

        if (mIsDragging.current) {
            setX(e.clientX - offset.current.x);
            setY(e.clientY - offset.current.y);
        }

    };

    const handleMouseUp = () => {
        mResizing.current = (null);
        setPointerEvents('all');
        setCardItemPointerEvent('all');
    };

    return(
        <Modal keyboard={!isPin} width={dialogSize.width} zIndex={props.data?.zIndex} mask={hasMaskLayer}
               open={props.data?.open} closable={false} closeIcon={<IconClose/>} footer={null} onCancel={()=> {
            setIsShowDialog(false);
            window.closeDialogMediaView(data);
        }} style={{
            minWidth: (dialogSize.width)+'px',
            margin:'0px',
            left:x+'px',
            top:y+'px',
            paddingBottom:'0px',
            // opacity:isVisible?'1':'0',
            display:isVisible?'':'none'
        }} styles={{
            wrapper: {
                overflow: "hidden",
                borderRadius: 0,
                pointerEvents:isPin?'none':'all',
            },
            content: {
                width: (dialogSize.width)+'px',
                height: (dialogSize.height) + "px",
                borderRadius: 10,
            }
        }} modalRender={(modal) => (
            <div className={'div-no-margin'} id={'drag-' + props.data?.id} ref={draggleRef} onMouseDown={(event) => {
                event.stopPropagation();
                if (!getIsPin())return;

                mIsDragging.current = true;
                offset.current.x = event.clientX - draggleRef.current.getBoundingClientRect().left;
                offset.current.y = event.clientY - draggleRef.current.getBoundingClientRect().top;
                setPointerEvents('none');
            }} onMouseMove={(event) => {
                if (mIsDragging.current) {
                    setX(event.clientX - offset.current.x);
                    setY(event.clientY - offset.current.y);
                }
            }} onMouseUp={(event) => {
                mIsDragging.current = false;
                setPointerEvents('all');
            }} style={{}} onClick={(event) => {
                event.stopPropagation();
                window.bringDialogMediaFront(data);
            }}>
                {modal}

                {/* 四个拖拽手柄 */}
                {
                    getIsPin() &&
                    <>
                        <div className="resize-handle top-left" onMouseDown={handleMouseDown('top-left')}/>
                        <div className="resize-handle top-right" onMouseDown={handleMouseDown('top-right')}/>
                        <div className="resize-handle bottom-left" onMouseDown={handleMouseDown('bottom-left')}/>
                        <div className="resize-handle bottom-right" onMouseDown={handleMouseDown('bottom-right')}/>
                        <div className="resize-handle left" onMouseDown={handleMouseDown('left')}/>
                        <div className="resize-handle right" onMouseDown={handleMouseDown('right')}/>
                        <div className="resize-handle top" onMouseDown={handleMouseDown('top')}/>
                        <div className="resize-handle bottom" onMouseDown={handleMouseDown('bottom')}/>
                    </>
                }

                {/* 你的内容 */}
            </div>
            // </Draggable>
        )}>
            <div style={{height:'100%',width:'100%',display:'flex',flexDirection:'column'}}>
                <div className={'flex-row-vertical-center'} style={{flexShrink: '0'}}>
                    <span className={'dialog-title'}>{data?.name || t("Untitled")}</span>
                    <div style={{flexGrow: '1'}}/>
                    {
                        <>
                            {
                                !isImage(data?.fileName) &&
                                <img className={'img-26 cursor-pointer hovered-gray-radius'}
                                     src={getImagePathWithTheme('media_anno')} onClick={async (event) => {
                                    //以注记的方式打开..
                                    event.stopPropagation();
                                    setIsShowDialog(false);
                                    window.closeDialogMediaView(data);

                                    const highlight = await dbGetHighlightByLibraryId(props.data.id);
                                    if (highlight) {//有视频注记，用视频注记打开
                                        if (!highlight.name) {
                                            highlight.name = props.data.name;
                                        }
                                        window.showVideoNotes(highlight);
                                    } else {
                                        window.showVideoNotes({...props.data, data: []});
                                    }
                                }}/>
                            }


                            <Tooltip overlayClassName='font-size-12'
                                     title={isPin ? t("UnpinFloatWindow") : t("PinAsFloatWindow")} zIndex={MAX_Z_INDEX}
                                     arrow={false}>
                                <img className='img-25 hovered-gray-radius ml-8' onClick={(event) => {
                                    event.stopPropagation();
                                    setTimeout(() => {
                                        const nPinCount = window.getDialogPinCount();
                                        if (nPinCount > 0) {
                                            setHasMaskLayer(false);
                                        } else {
                                            setHasMaskLayer(isPin);
                                        }
                                    }, 100);
                                    setIsPin(!isPin);
                                }} src={getImagePathWithTheme(isPin ? 'dialog_unpin' : 'dialog_pin')}/>
                            </Tooltip>
                        </>
                    }


                    <img className={'img-16 cursor-pointer ml-12'} src={getImagePathWithTheme('menu_show_info_1')}
                         onClick={(event) => {
                             event.stopPropagation();
                             window.showInfo('library', data);
                         }}/>
                    <Dropdown overlayClassName='default-dropdown-style'
                              menu={{items: menuItems, onClick: handleMenuClick}}
                              trigger={['click']}>
                        <img className={'img-13 ml-12 cursor-pointer'} onClick={(event)=>{
                            event.stopPropagation();
                        }}
                             src={getImagePathWithTheme('media_view_v_more')}/>
                    </Dropdown>

                    <img className='img-23 cursor-pointer ml-8'
                         src={getImagePathWithTheme('icon_pop_close_light.svg')}
                         onClick={(event)=>{
                             event.stopPropagation();
                        window.closeDialogMediaView(data);
                    }}/>

                </div>

                <div className={'mt-12 flex-center'}
                     style={{
                         width: '100%',
                         flexGrow: '1',
                         overflow: 'hidden',
                         height: '100%',
                         position: 'relative'  // 添加相对定位
                     }}>
                    {
                        data?.type == 'image' &&
                        <img
                            style={{
                                maxWidth: '100%',
                                maxHeight: '100%',
                                pointerEvents: 'auto'  // 确保图片可接收事件
                            }}
                            src={getLocalFilePath(data.fileName, data.isAbsolutePath)}
                            draggable="false"  // 禁用原生拖动
                        />
                        // <TransformWrapper
                        //     initialScale={1}
                        //     minScale={0.5}
                        //     maxScale={5}
                        //     initialPositionX={0}
                        //     initialPositionY={0}
                        //     onPanningStart={() => console.log('平移开始')}
                        //     onPanning={() => console.log('平移中')}
                        //     onPanningStop={() => console.log('平移结束')}
                        //     panning={{
                        //         disabled:false,
                        //         activationKeys: ["MouseLeft"] // 使用鼠标左键
                        //     }}
                        //     // 禁用双击动画（避免冲突）
                        //     doubleClick={{ disabled: true }}
                        //     pinch={{step:0.1}}
                        //     wheel={{ step: 0.01, smoothStep: 0.01 }}
                        //     centerZoomedOut ={false}
                        //     smooth={true}
                        //     centerOnInit={true}
                        //     alignmentAnimation={{disabled:true}}
                        //     onTransformed={(e)=>{
                        //         // console.log(e);
                        //     }}
                        // >
                        //     {(event) => (
                        //         <>
                        //             <TransformComponent
                        //                 wrapperStyle={{
                        //                     width: '100%',
                        //                     height: '100vh',
                        //                     touchAction: 'none',
                        //                     userSelect: 'none'  // 防止文本选择
                        //                 }}
                        //                 contentStyle={{
                        //                     // 移除 pointerEvents: 'none'
                        //                     touchAction: 'none',
                        //                     cursor:'grab'
                        //                 }}
                        //             >
                        //                 <img
                        //                     style={{
                        //                         maxWidth: '100%',
                        //                         maxHeight: '100%',
                        //                         pointerEvents: 'auto'  // 确保图片可接收事件
                        //                     }}
                        //                     src={getLocalFilePath(data.fileName, data.isAbsolutePath)}
                        //                     draggable="false"  // 禁用原生拖动
                        //                 />
                        //             </TransformComponent>
                        //         </>
                        //     )}
                        // </TransformWrapper>

                    }

                    {
                        data?.type == 'video' &&
                        <video onPlay={(event) => {
                            pauseAllVideo(event.target);
                        }} style={{background: 'black', objectFit: 'contain', width: '100%', height: '100%'}} controls
                               src={getLocalFilePath(data.fileName, data.isAbsolutePath)}/>
                    }

                    {
                        data?.type == 'audio' &&
                        <div style={{width: '100%', height: '100px'}}>
                            <CustomAudio ref={customAudioRef}
                                         szUrl={getLocalFilePath(data.fileName, data.isAbsolutePath)}
                                         from={FROM_DIALOG}/>
                        </div>

                    }

                </div>

            </div>
        </Modal>
    )
})

export default DialogMediaView;